import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { JSX } from 'react';
import { Text } from '../text';
interface Props {
  children: React.ReactNode;
  color?: string;
  testId?: string;
}
export function SmallCaps(props) {
  const $ = _c(5);
  const {
    children,
    color,
    testId
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      letterSpacing: "1px",
      textTransform: "uppercase",
      fontSize: "11px",
      lineHeight: "17px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== children || $[2] !== color || $[3] !== testId) {
    t1 = <Text style={t0} color={color} weight={600} testId={testId}>{children}</Text>;
    $[1] = children;
    $[2] = color;
    $[3] = testId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}